/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   media bizo Panoskin selectors
 */

import type { Media } from '@zcode/bizos'
import { memoizeSelector } from '@zcode/memoizers'

export const selectPanoskinUrl = memoizeSelector((media: Media | undefined) => {
  if (media?.isIframe && media.originUrl?.includes('panoskin')) {
    const { search } = new URL(media.originUrl)
    return search ? `https://viewer.panoskin.com/${search}` : null
  }
  return null
})
